export const _forceString = (text: string | null = '', trimmed = true) => {
  if (typeof text !== 'string') {
    text = '';
  }
  return trimmed ? text?.trim() : text;
};

export const _isNumeric = (value: string) => !isNaN(Number(value));

export function defaultIfEmpty(
  value: string | null | undefined,
  valueDefault: string,
): string {
  return _forceString(value) || valueDefault;
}
